import TripDetailsSubHeading from '../../tripDetailsSubHeading/TripDetailsSubHeading';
import './termsDis.css';

export default function TermsDis({ data }) {
    return (
        <div className='termsDisDiv'>
            <TripDetailsSubHeading text={'Terms'} />
            <div className='termsDisPoints'>
                <ul>
                    {data?.map((ter, terIndex) => {
                        return (
                            <li key={terIndex} className='termsDisText'>
                                ➡️ {ter}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}
